module.exports = __webpack_public_path__ + "static/media/institute-18-min.ff6ae723.webp";